import { FormattedMessage, useIntl } from 'react-intl';
import { useAuth } from '@auth';
import FormField from '@/shared/components/FormField';
import FormInput from '@/shared/components/FormInput';

export default function AccountPanel() {
  const intl = useIntl();
  const { user } = useAuth();

  const nameValue = user?.name ?? intl.formatMessage({ id: 'common.notAvailable' });
  const emailValue = user?.email ?? intl.formatMessage({ id: 'common.notAvailable' });
  const countryValue = user?.country ?? intl.formatMessage({ id: 'common.notAvailable' });

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-slate-900">
        <FormattedMessage id="settings.account.heading" />
      </h2>

      <div className="space-y-5">
        <FormField id="name" labelId="settings.account.nameLabel">
          <FormInput id="name" value={nameValue} disabled />
        </FormField>
        <FormField id="email" labelId="settings.account.emailLabel">
          <FormInput id="email" type="email" value={emailValue} disabled />
        </FormField>
        <FormField id="country" labelId="settings.account.countryLabel">
          <FormInput id="country" value={countryValue} disabled />
        </FormField>
      </div>
    </div>
  );
}
